import {jQuery as $} from 'lib/shim';

// import {generateObjectFitCallback} from 'util/objectfit';


const NAME = 'molecule-3d-viewer',
	SELECTOR = '.' + NAME;


let THREE_JS_SCRIPT_URL = '/js/lib-3d-viewer.js';


class Molecule3DViewer {

	constructor(app, $element) {
		if (!$.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$previewLayer = this._$element.find('.preview-layer').first();
			// this._$image = this._$previewLayer.find('.image-holder .image img');

			this._$loadingLayer = this._$element.find('.loading-layer').first();
			this._$progress = this._$loadingLayer.find('.progress').first();
			this._$canvas = this._$element.find('.canvas-view').first();

			// this._objectFitCallbackName = null;

			// this._modelScale = this._$element.data('scale');

			this._modelDataPaths = {
				gltf: this._$element.data('source'),
				hdr: this._$element.data('hdr-source')
			};

			this._viewerProps = {
				gltfLoader: null,
				camera: null,
				scene: null,
				renderer: null,
				controls: null
			};

			this._prime();
		}
	}


	_prime() {
		const _this_ = this;

		// this._objectFitCallbackName = generateObjectFitCallback({
		// 	callbackHandler: function (cb) {
		// 		_this_._app.registerFuzzyUpdateLoopCallback(NAME + '-' + _this_._id, cb);
		// 	},
		// 	$element: this._$image,
		// 	containerSelector: '.image-holder'
		// });

		this._$previewLayer.on('click', () => {
			$.getScript(THREE_JS_SCRIPT_URL)
				.done(() => {
					this._initViewer();
				});
		});
	}


	_initViewer() {
		const instance = this;
		const THREE = window._THREE;

		if (!THREE) {
			return;
		}

		this._$element.addClass('viewer-loading');

		this._$previewLayer.off('click');

		this._viewerProps.renderer = new THREE.WebGLRenderer({
			canvas: this._$canvas.get(0),
			antialias: true,
			alpha: true
		});

		this._viewerProps.renderer.setSize(this._$element.width(), this._$element.height());
		this._viewerProps.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
		this._viewerProps.renderer.shadowMap.enabled = true;
		this._viewerProps.renderer.gammaOutput = true;

		const fov = 50;
		const aspect = this._$element.width() / this._$element.height();
		const near = 0.01;
		const far = 1000;
		this._viewerProps.camera = new THREE.PerspectiveCamera(fov, aspect, near, far);

		this._viewerProps.camera.position.set(55, 55, 55);

		this._viewerProps.scene = new THREE.Scene();

		this._viewerProps.scene.add(this._viewerProps.camera);

		// Controls
		this._viewerProps.controls = new THREE.OrbitControls(this._viewerProps.camera, this._viewerProps.renderer.domElement);
		this._viewerProps.controls.enabled = true;
		this._viewerProps.controls.panSpeed = 0.8;
		this._viewerProps.controls.minDistance = 30;
		this._viewerProps.controls.minDistance = 30;
		this._viewerProps.controls.maxDistance = 140;


		//lights
		// const ambient = new THREE.AmbientLight( 0xffffff, 3 );
		// this._viewerProps.scene.add( ambient );
		// const hemiLight = new THREE.HemisphereLight( 0xffffff, 0xffffff, 0.8 );
		// hemiLight.position.set( 0, 20, 0 );
		// this._viewerProps.scene.add( hemiLight );
		// const dirLight = new THREE.DirectionalLight( 0xffffff, 60 );
		// // dirLight.position.set( 0, 20, 10 );
		// this._viewerProps.camera.add( dirLight );
		// const light = new THREE.PointLight(0xffffff, 0.8);
		// this._viewerProps.camera.add(light);


		instance._viewerProps.rgbeLoader = new THREE.RGBELoader();

		instance._viewerProps.rgbeLoader.load(instance._modelDataPaths.hdr, function (texture) {
				texture.mapping = THREE.EquirectangularReflectionMapping;
				// instance._viewerProps.scene.background = texture;
				instance._viewerProps.scene.environment = texture;

				instance._viewerProps.gltfLoader = new THREE.GLTFLoader();

				instance._viewerProps.gltfLoader.load(instance._modelDataPaths.gltf, function (object) {
						// if (instance._modelScale) {
						// 	object.scene.scale.set(instance._modelScale, instance._modelScale, instance._modelScale);
						// } else {
							object.scene.scale.set(50, 50, 50);
						// }

						instance._viewerProps.controls.target.copy(object.scene.position);
						instance._viewerProps.scene.add(object.scene);
						instance._$element.removeClass('viewer-loading');
						instance._$element.addClass('viewer-initialized');
						instance._$progress.remove();
					},
					// called when loading is in progresses
					function (xhr) {
						instance._$progress.html(Math.round(xhr.loaded / xhr.total * 100 * 100) / 100 + '% loaded');
					},
					// called when loading has errors
					function (error) {
						console.error('An error happened initializing the 3D viewer:\n', error);
					}
				);

				instance._animateView();
			},
			// called when loading is in progresses
			function (xhr) {
				// instance._$progress.html(Math.round(xhr.loaded / xhr.total * 100 * 100) / 100 + '% loaded');
			},
			// called when loading has errors
			function (error) {
				console.error('An error happened initializing the 3D viewer:\n', error);
			});

		this._app.registerResizeCallback(NAME + '-' + this._id, () => {
			this._viewerProps.camera.aspect = this._$element.width() / this._$element.height();
			this._viewerProps.camera.updateProjectionMatrix();

			this._viewerProps.renderer.setSize(this._$element.width(), this._$element.height());
		});
	}


	_animateView() {
		requestAnimationFrame(() => {
			this._animateView();
		});

		this._renderView();
	}


	_renderView() {
		this._viewerProps.camera.updateMatrixWorld();
		this._viewerProps.controls.update();

		this._viewerProps.renderer.render(this._viewerProps.scene, this._viewerProps.camera);
	}
}


export function init(app) {
	let $elements = $();

	$(SELECTOR).each(function () {
		let $this = $(this);
		new Molecule3DViewer(app, $this);
		$elements = $elements.add($this);
	});

	return $elements;
}
